<template>
  <div class="article-page">
    <single-press-release :pressReleaseId="$route.params.id">
      <template slot-scope="props">
        <div class="single-post" v-if="props.pressRelease">
          <div class="post-title-area">
            <h2 class="post-title">
              {{ props.pressRelease.titre }}
            </h2>
            <div class="post-meta">
              <span class="post-date"><i class="fa fa-clock-o"></i> {{ props.pressRelease.date }}</span>
            </div>
          </div><!-- Post title end -->

          <div class="post-content-area">
            <div class="entry-content" v-html="props.pressRelease.body_html"></div>

            <div class="share-items clearfix">
              <ul class="post-social-icons unstyled">
                <li class="facebook">
                  <a href="https://www.facebook.com/sharer/sharer.php" target="_blank">
                    <i class="fa fa-facebook"></i> <span class="ts-social-title">Facebook</span></a>
                </li>
                <li class="twitter">
                  <a :href="`https://twitter.com/home?status=${pageUrl}`" target="_blank">
                    <i class="fa fa-twitter"></i> <span class="ts-social-title">Twitter</span></a>
                </li>
                <li class="gplus">
                  <a :href="`https://plus.google.com/share?url=${pageUrl}`" target="_blank">
                    <i class="fa fa-google-plus"></i> <span class="ts-social-title">Google +</span></a>
                </li>
                <li class="linkedin">
                  <a :href="`https://www.linkedin.com/shareArticle?mini=true&url=${pageUrl}`" target="_blank">
                    <i class="fa fa-linkedin"></i> <span class="ts-social-title">Linkedin</span></a>
                </li>
              </ul>
            </div><!-- Share items end -->

          </div><!-- post-content end -->
          <div id="comments" class="comments-area block">
            <h3 class="block-title"><span>Commentaires</span></h3>
            <comments :id="props.pressRelease.id"></comments>
          </div>
        </div><!-- Single post end -->
      </template>
    </single-press-release>
    <br/><br/>
    <read-more/>
  </div>
</template>

<script>
  import { SinglePressRelease, Comments } from 'itrnews-vuejs-api';
  import website from '../mixins/website';
  import ReadMore from './ReadMore';

  export default {
    name: 'ArticlePage',
    components: { ReadMore, SinglePressRelease, Comments },
    mixins: [website],
    mounted() {
      this.pageUrl = window.location.href;
    },
    data() {
      return {
        tags: [],
        pageUrl: '',
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/PressReleasePage.vue